<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <h1 class="page-header">{{ title }}</h1>
        <div class="row">
          <div class="col-xs-12 col-sm-12">
            <list
              ref="vuetable"
              :show-empty="true"
              :title="'Listagem de ' + title"
              reportTitle="Dados"
              api-url="dado/listbyuserauth"
              :fields="model.columns"
              :initial-page="pagina"
              :pageCollection="'dados'"
              :appendParams="filtros"
            >
              <template slot="filters">
                <div class="collapse" id="filtros">
                  <div class="col-sm-12">
                    <label class="custom-font" for="nome_filter">Nome</label>
                    <input
                      type="text"
                      v-model="nome"
                      class="form-control"
                      name="nome_filter"
                    />
                  </div>
                  <div class="col-sm-4">
                    <label class="custom-font" for="DAD_DLFONTE_filter"
                      >Fonte</label
                    >
                    <input
                      type="text"
                      v-model="fonte"
                      name="DAD_DLFONTE_filter"
                      class="form-control"
                    />
                  </div>
                  <div class="col-sm-4">
                    <label class="custom-font" for="periodicidade_codigo_filter"
                      >Periodicidade</label
                    >
                    <select
                      v-model="periodicidade_codigo"
                      name="periodicidade_codigo_filter"
                      class="form-control select-selected"
                    >
                      <option value="*">Todas</option>
                      <option
                        v-for="i in periodicidades"
                        :key="i.codigo"
                        :value="i.codigo"
                      >
                        {{ i.descricao }}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-4">
                    <label class="custom-font" for="status_values_filter"
                      >Status de Preenchimento</label
                    >
                    <select
                      v-model="status_values"
                      name="status_values_filter"
                      class="form-control select-selected"
                    >
                      <option value="*">Todos</option>
                      <option value="completo">Completo</option>
                      <option value="pendente_ultimoano">
                        Ultimo ano pendente
                      </option>
                      <option value="pendente_anos_anteriores">
                        Anos anteriores pendente
                      </option>
                      <option value="nenhum">Sem lançamentos</option>
                    </select>
                  </div>
                  <div class="col-xs-12">
                    <button
                      @click="consultar()"
                      class="btn btn-default margem-topo"
                      name="btnFiltrar"
                    >
                      <font-awesome-icon :icon="'filter'"></font-awesome-icon>
                      Filtrar
                    </button>
                    <button
                      @click="limpar()"
                      class="btn btn-default margem-topo"
                      name="btnLimpar"
                    >
                      <font-awesome-icon :icon="'eraser'"></font-awesome-icon>
                      Limpar Filtros
                    </button>
                  </div>
                </div>
              </template>

              <template slot="actions">
                <button
                  class="btn btn-default"
                  data-toggle="collapse"
                  data-target="#filtros"
                >
                  <font-awesome-icon :icon="'filter'"></font-awesome-icon>
                  Filtros
                </button>
              </template>

              <template slot="ano1" slot-scope="props">
                <div class="">
                  <span>
                    <font-awesome-icon
                      v-if="props.rowData.hasValorAno1"
                      :icon="'check'"
                      style="color: green"
                    >
                    </font-awesome-icon>
                    <font-awesome-icon
                      v-else
                      :icon="'minus'"
                      style="color: red"
                    >
                    </font-awesome-icon>
                  </span>
                </div>
              </template>

              <template slot="ano2" slot-scope="props">
                <div class="">
                  <span>
                    <font-awesome-icon
                      v-if="props.rowData.hasValorAno2"
                      :icon="'check'"
                      style="color: green"
                    ></font-awesome-icon>
                    <font-awesome-icon
                      v-else
                      :icon="'minus'"
                      style="color: red"
                    ></font-awesome-icon>
                  </span>
                </div>
              </template>

              <template slot="ano3" slot-scope="props">
                <div class="">
                  <span>
                    <font-awesome-icon
                      v-if="props.rowData.hasValorAno3"
                      :icon="'check'"
                      style="color: green"
                    ></font-awesome-icon>
                    <font-awesome-icon
                      v-else
                      :icon="'minus'"
                      style="color: red"
                    ></font-awesome-icon>
                  </span>
                </div>
              </template>

              <template slot="ano4" slot-scope="props">
                <div class="">
                  <span>
                    <font-awesome-icon
                      v-if="props.rowData.hasValorAno4"
                      :icon="'check'"
                      style="color: green"
                    ></font-awesome-icon>
                    <font-awesome-icon
                      v-else
                      :icon="'minus'"
                      style="color: red"
                    ></font-awesome-icon>
                  </span>
                </div>
              </template>

              <template slot="rowrender" slot-scope="props">
                <div class="">
                  <router-link
                    title="Listar valores"
                    class="btn btn-primary"
                    :to="{
                      name: 'user_dado_valor_list',
                      params: { DAD_IDDADO: props.rowData.codigo },
                    }"
                  >
                    <font-awesome-icon :icon="'chart-bar'"></font-awesome-icon>
                  </router-link>
                </div>
              </template>
            </list>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userBase from '@/views/admin/dados/user/UserBase'
import list from '@/components/common/DataTable'
import { request } from '@/request'
export default {
  extends: userBase,
  data() {
    return {
      title: 'Dados',
      type: 'DADO',
      model: {
        columnID: 'codigo',
        columns: [],
      },
      periodicidades: [],
    }
  },
  components: { list },
  created() {
    this.createColumns()
    this.loadPeriodicidades()
  },
  methods: {
    createColumns() {
      this.model.columns = [
        {
          name: 'nome',
          title: 'Nome',
          dataClass: 'align-middle',
        },
        ...this.createColumnsYearStatusValue(),
        {
          name: 'periodicidade',
          title: 'Periodicidade',
          dataClass: 'align-middle col-md-1 text-center',
        },
        {
          name: 'fonte',
          title: 'Fonte',
          dataClass: 'align-middle',
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-3',
          dataClass: 'text-center',
        },
      ]
    },
    createColumnsYearStatusValue() {
      const columns = []
      const propertiesDefault = {
        titleClass: 'text-center',
        dataClass: 'align-middle text-center',
      }

      for (let index = 0; index < 4; index++) {
        columns.push({
          name: `__slot:icon${index + 1}`,
          columnName: `hasValorAno${index + 1}`,
          title: `${new Date().getFullYear() - (4 - index)}`,
          ...propertiesDefault,
        })
      }

      return columns
    },
    loadPeriodicidades() {
      request
        .get('listar-periodicidades')
        .then((response) => (this.periodicidades = response.data.data))
        .catch((error) => console.log(error))
    },
    consultar() {
      this.$refs.vuetable.refresh()
    },
    limpar() {
      this.nome = ''
      this.fonte = ''
      this.periodicidade_codigo = '*'
      this.status_values = '*'
      this.$refs.vuetable.refresh()
    },
  },
  computed: {
    filtros() {
      const { nome, fonte, periodicidade_codigo, status_values } = this
      return {
        nome,
        fonte,
        periodicidade_codigo,
        status_values,
      }
    },
    pagina: {
      get() {
        const { dados } = this.$store.state.vuetableState
        const { pagina } = dados
        return pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'dados',
          value: value,
        })
      },
    },
    nome: {
      get() {
        const { dados } = this.$store.state.vuetableState
        const { nome } = dados.filtros

        return nome
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'nome',
          collection: 'dados',
          value: value,
        })
      },
    },
    fonte: {
      get() {
        const { dados } = this.$store.state.vuetableState
        const { fonte } = dados.filtros

        return fonte
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'fonte',
          collection: 'dados',
          value: value,
        })
      },
    },
    periodicidade_codigo: {
      get() {
        const { dados } = this.$store.state.vuetableState
        const { periodicidade_codigo } = dados.filtros

        return periodicidade_codigo
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'periodicidade_codigo',
          collection: 'dados',
          value: value,
        })
      },
    },
    status_values: {
      get() {
        const { dados } = this.$store.state.vuetableState
        const { status_values } = dados.filtros

        return status_values
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'status_values',
          collection: 'dados',
          value: value,
        })
      },
    },
  },
}
</script>

<style scoped>
div.collapse > input.form-control {
  margin-bottom: 15px;
}
.custom-font {
  font-size: 16px;
  color: #00615c;
}

.select-selected {
  background-color: #eeeeee;
  color: #00615c;
}
</style>
 


// WEBPACK FOOTER //
// src/views/admin/dados/user/List.vue